export default "__VITE_ASSET__SZFDlkRU__"